import { useEffect } from 'react';

/**
 * Warn before tab close / refresh / external navigation while `dirty` is true.
 * SPA-internal navigation is not covered (would need a React Router blocker).
 */
export function useUnsavedChangesGuard(dirty: boolean) {
  useEffect(() => {
    if (!dirty) return;
    const handler = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = '';
    };
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [dirty]);
}
